import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import IfElseConditionalRender
  from '@avtechsoftware/react-component-library/src/components/common/ConditionalRender/IfElseConditionalRender/IfElseConditionalRender';
import ConditionalRender
  from '@avtechsoftware/react-component-library/src/components/common/ConditionalRender/ConditionalRender';
import { useDispatch, useSelector } from 'react-redux';
import ProgressSpinner from '@avtechsoftware/react-component-library/src/components/common/ProgressSpinner';
import { getNextNumericalName } from '@avtechsoftware/ra-javascript-utilities/src/utilities/validation/ObjectListUtils';
import RaaDefaultButton from '../../../common/RaaDefaultButton/RaaDefaultButton';
import QuickAlertSummaryView from './QuickAlertSummaryView/QuickAlertSummaryView';
import QuickAlertConfirmationPage from './QuickAlertConfirmationPage/QuickAlertConfirmationPage';
import { selectActiveSubscriptionCounts, selectSessionInformation } from '../../../../redux/slices/sessionSlice';
import {
  createNotificationGroup,
  selectNotificationGroupList,
} from '../../../../redux/slices/notificationGroupsSlice/notificationGroupsSlice';

function QuickAlertLayout() {
  const dispatch = useDispatch();
  const { activeSubscription } = useSelector(selectSessionInformation);
  const { alertLimit } = useSelector(selectActiveSubscriptionCounts);
  const { userId, email } = useSelector(selectSessionInformation);
  const notificationGroups = useSelector(selectNotificationGroupList);

  const [showConfirmationPage, setShowConfirmationPage] = useState(false);
  const [quickAlertsData, setQuickAlertsData] = useState([]);
  const hasAdvancedAlerting = activeSubscription.activeTierHasAdvancedAlerting === true;

  const [initialNotificationGroupId, setInitialNotificationGroupId] = React.useState(null);
  const [creatingNotificationGroup, setCreatingNotificationGroup] = React.useState(true);

  React.useEffect(() => {
    const createDefaultNotificationGroup = async () => {
      const payload = {
        name: getNextNumericalName(notificationGroups, 'New Notification Group', 'name'),
        // id: 0,
        recipients: [{
          transportId: 1,
          context: JSON.stringify({ emailAddress: email }),
          userId: userId ? parseInt(userId, 10) : null,
        }],
      };
      await dispatch(createNotificationGroup(payload)).unwrap()
        .then((res) => {
          setInitialNotificationGroupId(res.notificationGroup.id);
          setCreatingNotificationGroup(false);
        }).catch((err) => {
          // eslint-disable-next-line no-console
          console.log('error creating default notification group: ', err.message);
          setInitialNotificationGroupId(null);
          setCreatingNotificationGroup(false);
        });
    };
    createDefaultNotificationGroup();
  }, []);

  if (creatingNotificationGroup) {
    return (
      <div className="row d-flex justify-content-center mt-5">
        <div>
          <ProgressSpinner progressText="Loading..." />
        </div>
      </div>
    );
  }
  return (
    <>
      <div className="clearfix my-3">
        <h4 className="float-left">Quick Alert</h4>
        <ConditionalRender show={!showConfirmationPage}>
          <div className="float-right">
            <Link to="/s/alerts/">
              <RaaDefaultButton>
                Cancel
              </RaaDefaultButton>
            </Link>
          </div>
        </ConditionalRender>
      </div>
      <IfElseConditionalRender
        conditionalBool={showConfirmationPage}
        TrueComponent={QuickAlertConfirmationPage}
        trueProps={{
          hasAdvancedAlerting,
          quickAlertsData,
        }}
        FalseComponent={QuickAlertSummaryView}
        falseProps={{
          hasAdvancedAlerting,
          setShowConfirmationPage,
          setQuickAlertsData,
          alertLimit,
          initialNotificationGroupId,
        }}
      />
    </>
  );
}

export default QuickAlertLayout;
